import type { CMSColumnsContainerDTO } from "~/features/cms/types/dto";
import { useCMSComponentRenderer } from "~/features/cms/CMSComponentRendererContext";
import { styled } from "~/common/mui";
import { makeExternallyStyledElement } from "~/features/cms/utils/styles";

interface Props extends Omit<CMSColumnsContainerDTO, "type"> {
  className?: string;
}

const JUSTIFY_VALUES = {
  LEFT: "flex-start",
  CENTER: "center",
  RIGHT: "flex-end",
};

export const CMSColumnContainer = (props: Props) => {
  const renderCMSComponent = useCMSComponentRenderer();
  return (
    <StyledColumnContainer
      rootStyles={props.rootStyles}
      className={props.className}
      style={{ justifyContent: JUSTIFY_VALUES[props.alignment] }}
      id={props.htmlId}
    >
      {props.columns.map((column, index) => {
        return renderCMSComponent(column, undefined, index);
      })}
    </StyledColumnContainer>
  );
};

const ColumnContainer = styled("div")({
  display: "flex",
  margin: `calc(var(--gutter) / -2)`,
  flexFlow: "wrap",
});
const StyledColumnContainer = makeExternallyStyledElement(ColumnContainer);
